/** @module form */

/**
 * Initializes radiobuttons' and checkboxes' management of the disabled state.
 * Should not be referenced directly.
 * @param {HTMLElement[]} inputs - An array of radiobuttons and checkboxes to initialize.
 *
 * @private
 * @see {@link radioCheckboxes}
 */
export function initRadioCheckboxes(inputs) {
    let handleDisabledState = (input) => {
            input.closest('label').classList.toggle('is-disabled', Boolean(input.disabled));

            let use = input.parentElement.querySelectorAll('use');

            if (use && use.length) {
                use.forEach((useEl) => {
                    let href = useEl.getAttribute('href');

                    if (input.disabled && href.endsWith('--disabled') === false) {
                        href = href + '--disabled';
                    } else if (input.disabled === false) {
                        href = href.replace('--disabled', '');
                    }

                    useEl.setAttribute('href', href);
                });
            }
        },
        observer = new MutationObserver((mutations) => {
            mutations.forEach(({ attributeName, target }) => {
                if (attributeName === 'disabled') {
                    handleDisabledState(target);
                }
            });
        });

    inputs.forEach((input) => {
        if (input.disabled) {
            handleDisabledState(input);
        }

        observer.observe(input, { attributes: true });
    });
}
